module.exports = __webpack_public_path__ + "media/components/alert-table/static/icon-edit-51efcbdfffc07c15f782788681145d57.svg";